export enum CategoryManagementEvent {
  Notification = 'categoryManagement_notification',
}

export default CategoryManagementEvent;
